import { FC } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { RootState } from '../../../setup'
import { UserRoles } from '../../enums/userRoles'
import { DEFAULT_ROUTE } from '../../routing/routes.config'
import { UsersPage } from './UsersPage'

const UsersPageWrapper: FC = () => {
  const user = useSelector((state: RootState) => state.auth.user, shallowEqual);
  
  if(!user || user.role === UserRoles.CLIENT || user.role === UserRoles.FINAL_USER)
    return <Redirect to={DEFAULT_ROUTE} />;

  return (
    <>
      <UsersPage />
    </>
  )
}

export default UsersPageWrapper
